import React from "react";
import { Snackbar, Alert } from "@mui/material";

const PopupMessage = ({ messageType, message, messageOpen }) => {
  return (
    <Snackbar
      open={messageOpen}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        severity={messageType}
        sx={{
          fontSize: "0.875rem",
          padding: "12px",

          borderRadius: "8px",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          transition: "transform 0.3s ease, opacity 0.3s ease",
          "&:hover": {
            transform: "scale(1.05)",
            opacity: 0.9,
          },
          fontWeight: "600",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default PopupMessage;
